import * as React from 'react';
import { Button, Modal } from 'antd';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';

import { DataTableView, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { ObjectUtils } from 'src/core/utils/object';
import { VersionDocumentListController } from './parts/version-document-list.controller';
import { observable } from 'mobx';
import { EmailTemplatePreviewController } from 'src/app/general/email-document-template/parts/email-template-preview.controller';
import { EmailDocumentService } from 'src/app/general/email-document-template/email-document.service';
import { resolve } from 'inversify-react';

interface IDocumentGenerationViewProps extends ComponentViewProps<DataSet<IFileSystemSummary>> {
    downloadDocument: (fileSystem: IFileSystemSummary) => void;
	regenerateDocument: (fileSystem: IFileSystemSummary) => Promise<void>;
	sendEmailDocument: (fileSystem: IFileSystemSummary, templateId: number) => void
	contextService?: any;
	targetId?: number;
	usages: DocumentGenerationUsage;
}

@observer
export class DocumentGenerationView extends React.Component<IDocumentGenerationViewProps, any> {
    constructor(props: IDocumentGenerationViewProps) {
        super(props);
    }

    @autobind
    expandedRowRender(fileSystem: IFileSystemSummary) {
        return (
            <VersionDocumentListController
                downloadDocument={this.props.downloadDocument}
                fileName={fileSystem.filename}
                regenerateDocument={this.props.regenerateDocument}
                setBusy={this.props.setBusy}
            />
        );
    }

	@observable
	chooseTemplateModal: boolean = false;

	@observable
	templateId: number;

	@observable
	fileRecord: any;

	@autobind
	handleEmailTemplateSend(item: any) {
		
		this.templateId = item.templateId;
		this.chooseTemplateModal = true;
		this.fileRecord = item;
		this.requestEmailTemplates(this.templateId, this.props.targetId, this.props.usages);
	}

	@observable
	emailTemplates: IEmailDocumentTemplateSummary[];

	@observable
	emailTemplateId: number;

	@resolve
	emailDocumentService: EmailDocumentService;

	requestEmailTemplates(baseTemplateId, targetId, usages) {
		if (baseTemplateId == 0)
			return;

		this.props.setBusy(true);
		this.emailTemplates = [];
		this.templateId = 0;

		this.emailDocumentService.getDocumentTemplates(baseTemplateId, targetId, usages).then((result) => {
			this.emailTemplates = result.data;
			if (this.emailTemplates.length > 0) {
				this.emailTemplateId = this.emailTemplates[0].id;
			}
			this.props.setBusy(false);
		}).catch((error) => {
			this.props.setBusy(false);
		});
	}

    render() {
		return (
			<React.Fragment>
				<Modal
					style={{ top: 20 }}
					width='50%'
					visible={this.chooseTemplateModal}
					title={`Choose email template. The target will be ${this.props.usages}`}
					maskClosable={false}
					okText='Send Email'
					onCancel={() => this.chooseTemplateModal = false}
					onOk={() => { this.props.sendEmailDocument(this.fileRecord, this.emailTemplateId); this.chooseTemplateModal = false; this.templateId = 0; }}
					>
				
					<EmailTemplatePreviewController
						setBusy={this.props.setBusy}
						usages={this.props.usages}
						templates={this.emailTemplates}
						baseTemplateId={this.templateId}
						targetId={this.props.targetId ? this.props.targetId : 1}
						onTemplateSelected={(templateId) => this.emailTemplateId = templateId}
					/>
				</Modal>
				<DataTableView
					model={this.props.model}
					toolbarLeftItems={this.props.children}
					hideToolbar={ToolbarVisibility.hideModifyButtons | ToolbarVisibility.hideSearch}
					columns={[
						{
							title: 'Filename',
							key: 'filename',
							dataIndex: 'filename'
						},
						{
							title: 'Size',
							key: 'size',
							dataIndex: 'size',
							render: (value: number) => `${ObjectUtils.round(value / 1000)} Kb`
						},
						{
							title: 'Version',
							key: 'version',
							dataIndex: 'version'
						},
						{
							title: 'Status',
							key: 'statusMessage',
							dataIndex: 'statusMessage'
						},
						{
							title: 'Owner',
							key: 'ownerUserName',
							dataIndex: 'ownerUserName'
						},
						{
							title: '',
							key: 'download',
							render: (text, record: IFileSystemSummary) => <Button icon="download" onClick={() => this.props.downloadDocument(record)} />
						},
						{
							title: '',
							key: 'send',
							render: (text, record: IFileSystemSummary) => <Button icon="mail" onClick={() => this.handleEmailTemplateSend(record)} />
						}
					]}
					expandedRowRender={this.expandedRowRender}
					setBusy={this.props.setBusy}
				/>
		</React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/document-generation/document-generation.view.tsx